// Minimal Meta Pixel loader and helpers
// Uses REACT_APP_FB_PIXEL_ID; falls back to backend /public-config if unset.
// No-op on localhost.

const PIXEL_ID = process.env.REACT_APP_FB_PIXEL_ID;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const isLocalhost = () => {
  if (typeof window === 'undefined') return false;
  return /^(localhost|127\.0\.0\.1|\[::1\])$/.test(window.location.hostname);
};

let initialized = false;
let initInFlight = null;
const pendingEvents = [];
let readyResolvers = [];

function loadPixelScript() {
  console.log('initFacebookPixel called', { PIXEL_ID, BACKEND_URL });

  if (typeof window === 'undefined') return;
  if (window.fbq) return;
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
}

function doInit(id) {
  console.log('doInit called with id', id);
  try {
    if (!id || initialized) return;
    loadPixelScript();
    window.fbq && window.fbq('init', id);
    window.fbq && window.fbq('track', 'PageView');
    initialized = true;
    // Flush any queued events
    if (window.fbq && pendingEvents.length) {
      while (pendingEvents.length) {
        const { eventName, params } = pendingEvents.shift();
        try { window.fbq('track', eventName, params || {}); } catch (_) {}
      }
    }
    // Resolve waiters
    readyResolvers.forEach((r) => { try { r(); } catch (_) {} });
    readyResolvers = [];
  } catch (_) {
    // ignore
  }
}

export function initFacebookPixel() {
  if (typeof window === 'undefined') return;
  if (isLocalhost()) return;

  // If provided at build-time, init immediately.
  if (PIXEL_ID) {
    doInit(PIXEL_ID);
    return Promise.resolve(true);
  }

  // Else, try runtime fetch from backend /public-config (only once)
  if (!initInFlight && BACKEND_URL) {
    initInFlight = fetch(`${BACKEND_URL}/public-config`, { credentials: 'include' })
      .then(r => {
        console.log('public-config response status', r.status);
        return r.json();
      })
      .then(cfg => {
        console.log('public-config cfg', cfg);
        const id = cfg?.fbPixelId || null;
        console.log('public-config fbPixelId used in FE', id);
        if (id) doInit(id);
        else console.log('NO fbPixelId in cfg, pixel NOT initialized');
      })
      .catch((e) => {
        console.log('public-config fetch error', e);
      })
      .finally(() => { initInFlight = null; });
  }
  return initInFlight || Promise.resolve(false);
}

export function track(eventName, params = {}) {
  console.log('FB TRACK', eventName, params);
  if (typeof window === 'undefined') return;
  if (!window.fbq) {
    // Queue until initialized
    pendingEvents.push({ eventName, params });
    return;
  }
  try { window.fbq('track', eventName, params); } catch (_) {}
}

export function trackPageView() {
  track('PageView');
}

export function trackPurchase(value, currency = 'USD', extra = {}) {
  if (typeof window !== 'undefined') {
    // basic dedupe window to avoid double fires from onApprove + success step
    if (!window.__feltPurchaseDedupUntil || Date.now() > window.__feltPurchaseDedupUntil) {
      window.__feltPurchaseDedupUntil = Date.now() + 30 * 1000; // 30s
    } else {
      return;
    }
  }
  const payload = {
    value: typeof value === 'number' ? value : Number(value) || 0,
    currency,
    ...extra,
  };
  track('Purchase', payload);
}

// Allow callers to await pixel readiness
export function waitForPixelReady() {
  if (typeof window === 'undefined') return Promise.resolve(false);
  if (window.fbq && initialized) return Promise.resolve(true);
  return new Promise((resolve) => {
    readyResolvers.push(() => resolve(true));
  });
}


